import {GridItem} from '@chakra-ui/react';
import {keyBy} from 'lodash';
import React, {memo} from 'react';
import {AiOutlineClose} from 'react-icons/ai';
import {FaArrowRight} from 'react-icons/fa';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
import {ModalProps} from '~/types/general';
import {
  AppModal,
  Col,
  Row,
  UiBox,
  UiButton,
  UiCenter,
  UiCheckbox,
  UiGrid,
  UiIcon,
  UiImage,
  UiInput,
  UiSimpleGrid,
  UiText,
  UiTextarea,
} from '../elements';

interface Props {
  isShowing: boolean;
  onDismissModal: () => void;
  imgUrl: string;
  isCentered?: boolean;
}

const ViewImageModal = ({isShowing, onDismissModal, imgUrl, isCentered = false}: Props) => {
  const dispatch: AppDispatch = useDispatch();
  const onCloseModal = () => {
    onDismissModal();
  };

  const onClickSubmit = async (e: React.FormEvent) => {
    onCloseModal();
  };

  return !isShowing ? null : (
    <AppModal isCentered={isCentered} actions={null} isOpen={isShowing} onClose={onCloseModal} contentMinW="40%">
      <UiImage boxSize="100%" url={imgUrl} />
    </AppModal>
  );
};

export default memo(ViewImageModal);
